// █▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀█
// █        JESSE STEWART         █
// █        UX/UI Designer        █
// █     www.JesseStewart.com     █
// █                              █
// █   (c) All Rights Reserved    █
// █▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄█

import React from "react";
/** @jsx jsx */ import { css, jsx } from "@emotion/core";
import styled from "@emotion/styled";
import {
  // Import Const
  fonts,
  sizes,
  breakpoints,
  // Import Functions
  typeSet,
  uppercase,
  borderRadius,
  expandValue,
  transition
} from "../../helpers/theme";

var tinycolor = require("tinycolor2");

let TypepadStyles = props => css`
  padding: ${expandValue(sizes.space * 2)};
  max-width: ${expandValue(breakpoints[3])};
  margin: 0 auto;
  ${props.screenHeight && `min-height: 100vh`};
  ${props.pageTop && "padding-top:" + expandValue(sizes.space * 6)};
  @media (min-width: ${expandValue(breakpoints[3])}) {
    padding: ${expandValue(sizes.space * 4)};
    ${props.pageTop && "padding-top:" + expandValue(sizes.space * 8)};
  }
  ${props.style}
`;
let TypepadStyled = styled("div")`
  ${TypepadStyles}
`;

export class Typepad extends React.Component {
  render() {
    let screenHeight = false;
    if (this.props.screenHeight) {
      screenHeight = true;
    }
    let pageTop = false;
    if (this.props.pageTop) {
      pageTop = true;
    }
    let style = {};
    if (this.props.style) {
      style = this.props.style;
    }
    return (
      <TypepadStyled
        screenHeight={screenHeight}
        pageTop={pageTop}
        style={style}
      >
        {this.props.children}
      </TypepadStyled>
    );
  }
}

let typesetStyles = props => css`
  font-family: ${fonts.default};
  color: ${props.theme.colors.white};
  a {
    color: ${tinycolor(props.theme.colors.primary)
      .lighten(10)
      .brighten(7.5)
      .toString()};
    ${transition("all", sizes.timer + "ms")}
    text-decoration: none;
    &:hover {
      color: ${props.theme.colors.secondary};
    }
    &:focus {
      color: ${props.theme.colors.primary};
      text-decoration: underline;
    }
  }
  h1 {
    position: relative;
    font-family: ${fonts.display};
    font-weight: 300;
    ${typeSet(sizes.fontSize * 2.5)}
    margin-bottom: ${expandValue(sizes.space)};
    color: ${props.theme.colors.white};
    text-shadow: 0 ${expandValue(sizes.space * 0.125)} ${expandValue(
  sizes.space
)} ${tinycolor(props.theme.colors.primary)
  .setAlpha(0.4)
  .toString()};
    &.inverse {
      color: ${props.theme.colors.black};
    }
    &.line {
      margin-bottom: ${expandValue(sizes.space)};
      padding-bottom: ${expandValue(sizes.space)};
      &:after {
        box-shadow: 0 ${expandValue(sizes.space * 0.125)} ${expandValue(
  sizes.space
)} ${tinycolor(props.theme.colors.primary)
  .setAlpha(0.4)
  .toString()};
        content: ' ';
        width: ${expandValue(sizes.space * 4)};
        height: ${expandValue(sizes.space * 0.25)};
        background: ${props.theme.colors.secondary};
        position: absolute;
        bottom: -${expandValue(sizes.space * 0.125)};
        left: 0;
      }
    }
  }
  h2 {
    position: relative;
    font-family: ${fonts.display};
    font-weight: 300;
    ${typeSet(sizes.fontSize * 2)}
    margin-bottom: ${expandValue(sizes.space * 0.5)};
    color: ${props.theme.colors.white};
    text-shadow: 0 ${expandValue(sizes.space * 0.125)} ${expandValue(
  sizes.space
)} ${tinycolor(props.theme.colors.primary)
  .setAlpha(0.4)
  .toString()};
    &.inverse {
      color: ${props.theme.colors.black};
    }
    &.line {
      margin-bottom: ${expandValue(sizes.space)};
      padding-bottom: ${expandValue(sizes.space)};
      &:after {
        box-shadow: 0 ${expandValue(sizes.space * 0.125)} ${expandValue(
  sizes.space
)} ${tinycolor(props.theme.colors.primary)
  .setAlpha(0.4)
  .toString()};
        content: ' ';
        width: ${expandValue(sizes.space * 4)};
        height: ${expandValue(sizes.space * 0.25)};
        background: ${props.theme.colors.secondary};
        position: absolute;
        bottom: -${expandValue(sizes.space * 0.125)};
        left: 0;
      }
    }
  }
  h3 {
    position: relative;
    font-family: ${fonts.display};
    ${uppercase()}
    font-weight: 500;
    ${typeSet(sizes.fontSize * 1.5)}
    margin-bottom: ${expandValue(sizes.space * 0.5)};
    color: ${tinycolor(props.theme.colors.secondary)
      .lighten(10)
      .brighten(10)
      .toString()};
    text-shadow: 0 ${expandValue(sizes.space * 0.125)} ${expandValue(
  sizes.space
)} ${tinycolor(props.theme.colors.primary)
  .setAlpha(0.4)
  .toString()};
    &.inverse {
      color: ${props.theme.colors.black};
    }
    &.line {
      margin-bottom: ${expandValue(sizes.space)};
      padding-bottom: ${expandValue(sizes.space)};
      &:after {
        box-shadow: 0 ${expandValue(sizes.space * 0.125)} ${expandValue(
  sizes.space
)} ${tinycolor(props.theme.colors.primary)
  .setAlpha(0.4)
  .toString()};
        content: ' ';
        width: ${expandValue(sizes.space * 4)};
        height: ${expandValue(sizes.space * 0.25)};
        background: ${props.theme.colors.secondary};
        position: absolute;
        bottom: -${expandValue(sizes.space * 0.125)};
        left: 0;
      }
    }
  }
  h4 {
    position: relative;
    font-family: ${fonts.display};
    ${uppercase()}
    font-weight: 500;
    ${typeSet(sizes.fontSize * 1.25)}
    margin-bottom: ${expandValue(sizes.space * 0.5)};
    color: ${tinycolor(props.theme.colors.secondary)
      .lighten(10)
      .brighten(10)
      .toString()};
    text-shadow: 0 ${expandValue(sizes.space * 0.125)} ${expandValue(
  sizes.space
)} ${tinycolor(props.theme.colors.primary)
  .setAlpha(0.4)
  .toString()};
    &.inverse {
      color: ${props.theme.colors.black};
    }
    &.line {
      margin-bottom: ${expandValue(sizes.space)};
      padding-bottom: ${expandValue(sizes.space)};
      &:after {
        box-shadow: 0 ${expandValue(sizes.space * 0.125)} ${expandValue(
  sizes.space
)} ${tinycolor(props.theme.colors.primary)
  .setAlpha(0.4)
  .toString()};
        content: ' ';
        width: ${expandValue(sizes.space * 4)};
        height: ${expandValue(sizes.space * 0.25)};
        background: ${props.theme.colors.secondary};
        position: absolute;
        bottom: -${expandValue(sizes.space * 0.125)};
        left: 0;
      }
    }
  }
  h5 {
    position: relative;
    font-family: ${fonts.display};
    ${uppercase()}
    font-weight: 500;
    ${typeSet(sizes.fontSize)}
    margin-bottom: ${expandValue(sizes.space * 0.5)};
    color: ${tinycolor(props.theme.colors.primary)
      .lighten(10)
      .brighten(10)
      .toString()};
    text-shadow: 0 ${expandValue(sizes.space * 0.125)} ${expandValue(
  sizes.space
)} ${tinycolor(props.theme.colors.primary)
  .setAlpha(0.4)
  .toString()};
    &.inverse {
      color: ${props.theme.colors.black};
    }
    &.line {
      margin-bottom: ${expandValue(sizes.space)};
      padding-bottom: ${expandValue(sizes.space)};
      &:after {
        box-shadow: 0 ${expandValue(sizes.space * 0.125)} ${expandValue(
  sizes.space
)} ${tinycolor(props.theme.colors.primary)
  .setAlpha(0.4)
  .toString()};
        content: ' ';
        width: ${expandValue(sizes.space * 4)};
        height: ${expandValue(sizes.space * 0.25)};
        background: ${props.theme.colors.secondary};
        position: absolute;
        bottom: -${expandValue(sizes.space * 0.125)};
        left: 0;
      }
    }
  }
  p {
    font-family: ${fonts.paragraph};
    ${typeSet(sizes.fontSize)}
    margin-bottom: ${expandValue(sizes.space * 0.5)};
    font-weight: 300;
    color: ${props.theme.colors.white};

    strong {
      font-weight: 700;
    }
    em {
      text-shadow: 0 ${expandValue(sizes.space * 0.125)} ${expandValue(
  sizes.space
)} ${tinycolor(props.theme.colors.primary)
  .setAlpha(0.4)
  .toString()};
      color: ${tinycolor(props.theme.colors.secondary)
        .lighten(20)
        .toString()};
      font-family: ${fonts.serif};
      font-style: italic;
      font-weight: 300;
    }
    &.inverse {
      color: ${props.theme.colors.black};
    }
  }
  address {
    display: block;
    font-style: normal;
    font-family: ${fonts.paragraph};
    ${typeSet(sizes.fontSize)}
    margin-bottom: ${expandValue(sizes.space * 0.5)};
    font-weight: 500;
    color: ${props.theme.colors.white};
    &.inverse {
      color: ${props.theme.colors.black};
    }
  }
  dl {
    dt {
      ${typeSet(sizes.fontSize)}
      ${uppercase()}
      font-weight: 300;
    }
    dd {
      margin: 0 0 ${expandValue(sizes.space)};
      padding: 0;
      ${typeSet(sizes.fontSize)}
    }
  }
  ol, ul {
    margin-bottom: ${expandValue(sizes.space * 0.5)};
    li {
      padding-left: ${expandValue(sizes.space * 1.5)};
      font-weight: 300;
      ${typeSet(sizes.fontSize)}
      ${transition("all", sizes.timer + "ms")}
      color: ${props.theme.colors.white};
      &:hover {
        color: ${tinycolor(props.theme.colors.secondary)
          .lighten(10)
          .brighten(10)
          .toString()};
      }
      .checkbox {
        margin-left: -${expandValue(sizes.space * 1.5)};
        margin-right: ${expandValue(sizes.space * 0.5)};
      }
      .done {
        position: relative;
        color: ${tinycolor(props.theme.colors.secondary)
          .lighten(10)
          .brighten(10)
          .toString()};
        opacity: 0.6;
      }
      @media (min-width: ${expandValue(breakpoints[3])}) {
        padding-left: ${expandValue(sizes.space * 2.5)};
        ${typeSet(sizes.fontSize * 2)}
        .checkbox {
          margin-left: -${expandValue(sizes.space * 2.5)};
        }
      }

      .done:after {
        @keyframes strike{
          0%   { right: 0; }
          100% { right: calc(0% - ${expandValue(sizes.space)}); }
        }
        content: ' ';
        position: absolute;
        height: 1px;
        bottom: ${expandValue(sizes.space * 0.375)};
        left: calc(100% - ${expandValue(sizes.space * 0.5)});
        right: 0;
        animation-name: strike;
        animation-duration: ${sizes.timer * 2}ms;
        animation-timing-function: ease-in;
        animation-iteration-count: 1;
        animation-fill-mode: forwards;
        background: ${tinycolor(props.theme.colors.secondary)
          .lighten(10)
          .brighten(10)
          .toString()};
        @media (min-width: ${expandValue(breakpoints[3])}) {
          height: 2px;
          left: calc(100% - ${expandValue(sizes.space)});
          @keyframes strike{
            0%   { right: 0; }
            100% { right: calc(0% - ${expandValue(sizes.space * 2)}); }
          }
          bottom: ${expandValue(sizes.space * 0.75)};
        }
      }

    }
  }
  ol.tags, ul.tags {
    li {
      padding: 0;
      font-weight: 300;
      ${typeSet(sizes.fontSize * 0.75)}
      color: ${tinycolor(props.theme.colors.primary)
        .lighten(10)
        .brighten(7.5)
        .toString()};
      ${uppercase()}
      &:hover {
        color: ${tinycolor(props.theme.colors.secondary)
          .lighten(15)
          .brighten(15)
          .toString()};
      }
      &.label {
        font-weight: 500;
        color: ${tinycolor(props.theme.colors.primary)
          .lighten(15)
          .brighten(15)
          .toString()};
      }
    }
    &.list-inline {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      li {
        margin-right: ${expandValue(sizes.space * 0.5)};
      }
    }
    &.inverse {
      li {
        color: ${tinycolor(props.theme.colors.primary)
          .darken(25)
          .toString()};
        &:hover {
          color: ${tinycolor(props.theme.colors.secondary)
            .darken(25)
            .toString()};
        }
        &.label {
          color: ${tinycolor(props.theme.colors.primary)
            .darken(15)
            .toString()};
        }
      }
    }
  }
  .lead {
    ${typeSet(sizes.fontSize * 1.5)}
    font-weight: 100;
  }
  .text-lg {
    ${typeSet(sizes.fontSize * 1.25)}
    font-weight: 200;
  }
  .display {
    ${typeSet(sizes.fontSize * 4)}
    font-weight: 300;
  }
  .no-break {
    white-space: nowrap;
  }
  @media (min-width: ${expandValue(breakpoints[3])}) {
    h1 {
      ${typeSet(sizes.fontSize * 4)}
      margin-bottom: ${expandValue(sizes.space * 2)};
      &.line {
        padding-bottom: ${expandValue(sizes.space * 2)};
      }
    }
    h2 {
      ${typeSet(sizes.fontSize * 3)}
    }
    h3 {
      ${typeSet(sizes.fontSize * 1.75)}
    }
    .lead {
      ${typeSet(sizes.fontSize * 1.5)}
    }
    .display {
      ${typeSet(sizes.fontSize * 6)}
    }
  }
  .inverse {
    h1, h2, h3, h4, h5, p, address {
      color: ${props.theme.colors.black};
    }
  }
`;
let TypesetStyled = styled("div")`
  ${typesetStyles}
`;

export class Typeset extends React.Component {
  render() {
    return <TypesetStyled>{this.props.children}</TypesetStyled>;
  }
}

let imgStyles = props => css`
  img {
    max-width: 100%;
    display: block;
    margin: 0 auto;
  }
`;
let ImgStyled = styled("div")`
  ${imgStyles}
`;

export class Img extends React.Component {
  render() {
    return <ImgStyled>{this.props.children}</ImgStyled>;
  }
}

let ImgFillStyles = props => css`
  * > a {
    display: block;
    width: 100%;
    height: 100%;
  }
  img {
    width: 100%;
    display: block;
    margin: 0 auto;
  }
`;
let ImgFillStyled = styled("div")`
  ${ImgFillStyles}
`;

export class ImgFill extends React.Component {
  render() {
    return <ImgFillStyled>{this.props.children}</ImgFillStyled>;
  }
}

let ImgPadStyles = props => css`
  padding: ${expandValue(sizes.space * 0.5)};
  img {
    max-width: 100%;
    display: block;
    margin: 0 auto;
    ${props.dropShadow &&
      "box-shadow: 0 0 " +
        expandValue(sizes.space) +
        " " +
        tinycolor(props.theme.colors.black)
          .setAlpha(0.2)
          .toString()}
  }
  @media (min-width: ${expandValue(breakpoints[3])}) {
    padding: ${expandValue(sizes.space * 2)};
  }
`;
let ImgPadStyled = styled("div")`
  ${ImgPadStyles}
`;

export class ImgPad extends React.Component {
  render() {
    let dropShadow = false;
    if (this.props.dropShadow) {
      dropShadow = true;
    }
    return (
      <ImgPadStyled dropShadow={dropShadow} style={this.props.styles}>
        {this.props.children}
      </ImgPadStyled>
    );
  }
}

let ImgIsoStyles = props => css`
  height: 56.25vw;
  overflow: hidden;
  position: relative;
  background: linear-gradient(
    240deg,
    rgba(0, 0, 0, 0.25) 0%,
    rgba(0, 0, 0, 0) 100%
  );
  .canvas {
    transform: translateY(-50%);
    position: absolute;
    top: 50%;
  }
  .image {
    transform: rotateX(54.7deg) rotateY(0deg) rotateZ(-45deg);
  }
  img {
    max-width: 100%;
    display: block;
    margin: 0 auto;
    ${transition("all", sizes.timer * 2 + "ms")}
    transform: scale(1) translateX(0) translateY(0);
    ${props.dropShadow &&
      "box-shadow: -" +
        expandValue(sizes.space * 0.25) +
        " " +
        expandValue(sizes.space * 0.25) +
        " " +
        expandValue(sizes.space) +
        " " +
        tinycolor(props.theme.colors.black)
          .setAlpha(0.4)
          .toString()};
    &:hover {
      transform: scale(1.02) translateX(24px) translateY(-24px);
      ${props.dropShadow &&
        "box-shadow: -" +
          expandValue(sizes.space) +
          " " +
          expandValue(sizes.space) +
          " " +
          expandValue(sizes.space * 2) +
          " " +
          tinycolor(props.theme.colors.black)
            .setAlpha(0.4)
            .toString()};
    }
  }
  @media (min-width: ${expandValue(breakpoints[3])}) {
    padding: ${expandValue(sizes.space * 2)};
  }
`;
let ImgIsoStyled = styled("div")`
  ${ImgIsoStyles}
`;

export class ImgIso extends React.Component {
  render() {
    let dropShadow = false;
    if (this.props.dropShadow) {
      dropShadow = true;
    }
    return (
      <ImgIsoStyled dropShadow={dropShadow} style={this.props.style}>
        <div className="canvas">
          <div className="image">{this.props.children}</div>
        </div>
      </ImgIsoStyled>
    );
  }
}

let FatBottomStyles = props => css`
  height: ${expandValue(sizes.space)};
  @media (min-width: ${expandValue(breakpoints[3])}) {
    height: ${expandValue(sizes.space * 3)};
  }
`;
let FatBottomStyled = styled("div")`
  ${FatBottomStyles}
`;

export class FatBottom extends React.Component {
  render() {
    return <FatBottomStyled>{this.props.children}</FatBottomStyled>;
  }
}

let imgLinkStyles = props => css`
  transform: scale(1);
  ${transition("all", sizes.timer + "ms")}
  img, svg {
    width: 100%;
    max-width: 100%;
    display: block;
  }
  &:hover {
    transform: scale(1.05);
  }
`;
let ImgLinkStyled = styled("div")`
  ${imgLinkStyles}
`;

export class ImgLink extends React.Component {
  render() {
    return <ImgLinkStyled>{this.props.children}</ImgLinkStyled>;
  }
}

let PageContainerStyles = props => css``;
let PageContainerStyled = styled("div")`
  ${PageContainerStyles}
`;

export class PageContainer extends React.Component {
  render() {
    return <PageContainerStyled>{this.props.children}</PageContainerStyled>;
  }
}

let BgColorStyles = props => css`
  background: linear-gradient(
    240deg,
    ${tinycolor(props.theme.colors.bg1)
        .darken(10)
        .setAlpha(0.6)
        .toString()}
      0%,
    ${tinycolor(props.theme.colors.bg1)
        .darken(15)
        .setAlpha(0.6)
        .toString()}
      100%
  );
`;
let BgColorStyled = styled("div")`
  ${BgColorStyles}
`;

export class BgColor extends React.Component {
  render() {
    return <BgColorStyled>{this.props.children}</BgColorStyled>;
  }
}

let BgColor2Styles = props => css`
  background-color: ;
  background: linear-gradient(
    240deg,
    ${tinycolor(props.theme.colors.bg2)
        .darken(10)
        .setAlpha(0.6)
        .toString()}
      0%,
    ${tinycolor(props.theme.colors.bg2)
        .darken(15)
        .setAlpha(0.6)
        .toString()}
      100%
  );

  ${props.opaque &&
    "background: linear-gradient(240deg," +
      tinycolor(props.theme.colors.bg2)
        .darken(15)
        .toString() +
      "0%, " +
      tinycolor(props.theme.colors.bg2)
        .darken(20)
        .toString() +
      " 100%);"}
`;
let BgColor2Styled = styled("div")`
  ${BgColor2Styles}
`;

export class BgColor2 extends React.Component {
  render() {
    let style = {};
    if (this.props.style) {
      style = this.props.style;
    }
    let opaque = false;
    if (this.props.opaque) {
      opaque = true;
    }
    return (
      <BgColor2Styled style={style} opaque={opaque}>
        {this.props.children}
      </BgColor2Styled>
    );
  }
}

// ICONS

let IconEmailStyles = props => css`
  position: relative;
  margin-top: -${expandValue(sizes.space * 0.25)};
  top: ${expandValue(sizes.space * 0.25)};
  width: ${expandValue(sizes.space)};
  height: ${expandValue(sizes.space)};
  display: inline-block;
  .st0_iemail {
    stroke: ${tinycolor(props.theme.colors.primary)
      .lighten(20)
      .toString()};
    fill: transparent;
  }
`;
let IconEmailStyled = styled("span")`
  ${IconEmailStyles}
`;

export class IconEmail extends React.Component {
  render() {
    return (
      <IconEmailStyled>
        <svg
          version="1.1"
          id="Layer_1"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          width="100%"
          viewBox="0 0 48 48"
          style={{ enableBackground: "new 0 0 48 48" }}
          xmlSpace="preserve"
        >
          <path
            className="st0_iemail"
            vectorEffect="non-scaling-stroke"
            d="M11 12h26c1.7 0 3 1.3 3 3v18c0 1.7-1.3 3-3 3H11c-1.7 0-3-1.3-3-3V15c0-1.7 1.3-3 3-3z"
          />
          <path
            className="st0_iemail"
            vectorEffect="non-scaling-stroke"
            d="M8 16l13.3 6.6c1.7.8 3.7.8 5.3 0L40 16"
          />
        </svg>
      </IconEmailStyled>
    );
  }
}

let IconWwwStyles = props => css`
  position: relative;
  margin-top: -${expandValue(sizes.space * 0.25)};
  top: ${expandValue(sizes.space * 0.25)};
  width: ${expandValue(sizes.space)};
  height: ${expandValue(sizes.space)};
  display: inline-block;
  .st0_iwww {
    stroke: ${tinycolor(props.theme.colors.primary)
      .lighten(20)
      .toString()};
    fill: transparent;
  }
`;
let IconWwwStyled = styled("span")`
  ${IconWwwStyles}
`;

export class IconWww extends React.Component {
  render() {
    return (
      <IconWwwStyled>
        <svg
          version="1.1"
          id="Layer_1"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          width="100%"
          viewBox="0 0 48 48"
          style={{ enableBackground: "new 0 0 48 48" }}
          xmlSpace="preserve"
        >
          <circle
            className="st0_iwww"
            vectorEffect="non-scaling-stroke"
            cx={24}
            cy={24}
            r={18}
          />
          <ellipse
            className="st0_iwww"
            vectorEffect="non-scaling-stroke"
            cx={24}
            cy={24}
            rx={9}
            ry={18}
          >
            <path
              className="st0_iwww"
              vectorEffect="non-scaling-stroke"
              d="M24,42L24,42"
            >
              <path
                className="st0_iwww"
                vectorEffect="non-scaling-stroke"
                d="M24,6L24,6"
              />
            </path>
          </ellipse>
          <line
            className="st0_iwww"
            vectorEffect="non-scaling-stroke"
            x1="7.3"
            y1={18}
            x2="40.7"
            y2={18}
          />
          <line
            className="st0_iwww"
            vectorEffect="non-scaling-stroke"
            x1="7.3"
            y1={30}
            x2="40.7"
            y2={30}
          />
        </svg>
      </IconWwwStyled>
    );
  }
}

let IconPhoneStyles = props => css`
  position: relative;
  margin-top: -${expandValue(sizes.space * 0.25)};
  top: ${expandValue(sizes.space * 0.25)};
  width: ${expandValue(sizes.space)};
  height: ${expandValue(sizes.space)};
  display: inline-block;
  .st0_iphone {
    stroke: ${tinycolor(props.theme.colors.primary)
      .lighten(20)
      .toString()};
    fill: transparent;
  }
`;
let IconPhoneStyled = styled("span")`
  ${IconPhoneStyles}
`;

export class IconPhone extends React.Component {
  render() {
    return (
      <IconPhoneStyled>
        <svg
          version="1.1"
          id="Layer_1"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          width="100%"
          viewBox="0 0 48 48"
          style={{ enableBackground: "new 0 0 48 48" }}
          xmlSpace="preserve"
        >
          <path
            className="st0_iphone"
            vectorEffect="non-scaling-stroke"
            d="M35,9.4v29.2c0,1.9-1.2,3.4-2.8,3.4H15.8c-1.5,0-2.8-1.5-2.8-3.4V9.4C13,7.5,14.2,6,15.8,6h16.5
          	C33.8,6.1,35,7.6,35,9.4z"
          />
          <circle className="st0_iphone" cx={24} cy="36.3" r="2.4" />
        </svg>
      </IconPhoneStyled>
    );
  }
}

let IconLinkedinStyles = props => css`
  position: relative;
  margin-top: -${expandValue(sizes.space * 0.25)};
  top: ${expandValue(sizes.space * 0.25)};
  width: ${expandValue(sizes.space)};
  height: ${expandValue(sizes.space)};
  display: inline-block;
  .st0_ilnkedin {
    stroke: ${tinycolor(props.theme.colors.primary)
      .lighten(20)
      .toString()};
    fill: transparent;
  }
`;
let IconLinkedinStyled = styled("span")`
  ${IconLinkedinStyles}
`;

export class IconLinkedin extends React.Component {
  render() {
    return (
      <IconLinkedinStyled>
        <svg
          version="1.1"
          id="Layer_1"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          width="100%"
          viewBox="0 0 48 48"
          style={{ enableBackground: "new 0 0 48 48" }}
          xmlSpace="preserve"
        >
          <path
            className="st0_ilnkedin"
            vectorEffect="non-scaling-stroke"
            d="M37,40H11c-1.7,0-3-1.3-3-3V11c0-1.7,1.3-3,3-3h26c1.7,0,3,1.3,3,3v26C40,38.7,38.7,40,37,40z"
          />
          <line
            className="st0_ilnkedin"
            vectorEffect="non-scaling-stroke"
            x1="16.1"
            y1="19.6"
            x2="16.1"
            y2="33.3"
          />
          <line
            className="st0_ilnkedin"
            vectorEffect="non-scaling-stroke"
            x1="22.9"
            y1="19.6"
            x2="22.9"
            y2="33.3"
          />
          <line
            className="st0_ilnkedin"
            vectorEffect="non-scaling-stroke"
            x1="16.1"
            y1="14.7"
            x2="16.1"
            y2="13"
          />
          <path
            className="st0_ilnkedin"
            vectorEffect="non-scaling-stroke"
            d="M22.9,25.8c0-2.5,2-4.5,4.5-4.5s4.5,2,4.5,4.5v7.4"
          />
        </svg>
      </IconLinkedinStyled>
    );
  }
}

let IconBoxStyles = props => css`
  position: relative;
  margin-top: -${expandValue(sizes.space * 0.25)};
  top: ${expandValue(sizes.space * 0.25)};
  width: ${expandValue(sizes.space)};
  height: ${expandValue(sizes.space)};
  display: inline-block;
  @media (min-width: ${expandValue(breakpoints[3])}) {
    margin-top: -${expandValue(sizes.space * 0.5)};
    top: ${expandValue(sizes.space * 0.5)};
    width: ${expandValue(sizes.space * 2)};
    height: ${expandValue(sizes.space * 2)};
  }
  .st0_ibox {
    stroke: ${tinycolor(props.theme.colors.primary)
      .lighten(20)
      .toString()};
    fill: transparent;
  }
`;
let IconBoxStyled = styled("span")`
  ${IconBoxStyles}
`;

export class IconBox extends React.Component {
  render() {
    return (
      <IconBoxStyled className="checkbox">
        <svg
          version="1.1"
          id="Layer_1"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          width="100%"
          viewBox="0 0 48 48"
          style={{ enableBackground: "new 0 0 48 48" }}
          xmlSpace="preserve"
        >
          <path
            className="st0_ibox"
            vectorEffect="non-scaling-stroke"
            d="M37,40H11c-1.7,0-3-1.3-3-3V11c0-1.7,1.3-3,3-3h26c1.7,0,3,1.3,3,3v26C40,38.7,38.7,40,37,40z"
          />
        </svg>
      </IconBoxStyled>
    );
  }
}

let IconBoxCheckStyles = props => css`
  position: relative;
  margin-top: -${expandValue(sizes.space * 0.25)};
  top: ${expandValue(sizes.space * 0.25)};
  width: ${expandValue(sizes.space)};
  height: ${expandValue(sizes.space)};
  display: inline-block;
  @media (min-width: ${expandValue(breakpoints[3])}) {
    margin-top: -${expandValue(sizes.space * 0.5)};
    top: ${expandValue(sizes.space * 0.5)};
    width: ${expandValue(sizes.space * 2)};
    height: ${expandValue(sizes.space * 2)};
  }
  .st0_ibox {
    stroke: ${tinycolor(props.theme.colors.primary)
      .lighten(20)
      .toString()};
    fill: transparent;
  }
  .animate-line {
    stroke-dasharray: 26;
    stroke-dashoffset: 26;
    animation: dash ${sizes.timer * 2}ms linear forwards;
  }
  @keyframes dash {
    to {
      stroke-dashoffset: 0;
    }
  }
`;
let IconBoxCheckStyled = styled("span")`
  ${IconBoxCheckStyles}
`;

export class IconBoxCheck extends React.Component {
  render() {
    return (
      <IconBoxCheckStyled className="checkbox checked">
        <svg
          version="1.1"
          id="Layer_1"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          width="100%"
          viewBox="0 0 48 48"
          style={{ enableBackground: "new 0 0 48 48" }}
          xmlSpace="preserve"
        >
          <path
            className="st0_ibox"
            vectorEffect="non-scaling-stroke"
            d="M37,40H11c-1.7,0-3-1.3-3-3V11c0-1.7,1.3-3,3-3h26c1.7,0,3,1.3,3,3v26C40,38.7,38.7,40,37,40z"
          />
          <polyline
            className="st0_ibox animate-line"
            vectorEffect="non-scaling-stroke"
            points="15,25.3 20.1,30.4 33,17.6 "
          />
        </svg>
      </IconBoxCheckStyled>
    );
  }
}

let DatesRangeStyles = props => css`
  ${typeSet(sizes.fontSize * 0.75)}
  ${uppercase()}
  margin-bottom: ${expandValue(sizes.space * 0.5)};
  font-weight: 300;
  color: ${tinycolor(props.theme.colors.secondary)
    .lighten(10)
    .brighten(7.5)
    .toString()};
  .date {
    text-align: center;
    ${borderRadius(sizes.space * 0.25)};
    display: inline-block;
    border: 1px solid ${tinycolor(props.theme.colors.secondary)
      .setAlpha(0.5)
      .toRgbString()};
    padding: 0 ${expandValue(sizes.space * 0.5)};
    margin: ${expandValue((0 + sizes.cap) * 0.5)} 0 ${expandValue(
  (0 - sizes.cap) * 0.5
)};
    white-space: nowrap;
  }
  &.inverse {
    color: ${tinycolor(props.theme.colors.secondary)
      .darken(25)
      .toString()};
    .date {
      border-color: ${tinycolor(props.theme.colors.secondary)
        .darken(25)
        .setAlpha(0.5)
        .toRgbString()};
    }
  }
`;
let DatesRangeStyled = styled("div")`
  ${DatesRangeStyles}
`;

export class DatesRange extends React.Component {
  render() {
    let className = "";
    if (this.props.className) {
      className = this.props.className;
    }
    return (
      <DatesRangeStyled className={className}>
        <div className="date">{this.props.children}</div>
      </DatesRangeStyled>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Partials/Typeset.js